import moment from "moment";

export const getColumn = (body) => [
  {
    label: "Sr no",
    id: "srNo",
    isComponent: true,
    component: (_, key) => (
      <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
    ),
  },
  {
    label: "Date of Transaction",
    id: "bookingDate",
    isComponent: true,
    component: (item) => (
      <p className={`  m-0`}>
        {moment(item.createdAt).format("MM/DD/YYYY")}
      </p>
    ),
  },
  { label: "Amount", id: "amount", classNames: " fw-sbold" , 
    isComponent: true,
    component: (item) => (
      <p className={`  m-0`}>
        ${item.amount}
      </p>
    ),
   },
  { label: "Balance Left in wallet", id: "balance", classNames: " fw-sbold" , 
    isComponent: true,
    component: (item) => (
      <p className={`  m-0`}>
        ${item.balance}
      </p>
    ),
   },
  { label: "Type", id: "type", classNames: " fw-sbold text-danger" },

  {
    label: "Description",
    id: "description",
    classNames: "fw-sbold ",
  },
];
